export default "__VITE_ASSET__Bc1RD6mO__"